import { connect } from 'react-redux'
import ErrorBoundary from './component'
import { launcherOpenUrl, selectors as imported } from '../imports'
import { getFallbackAds } from '../data/api'

function mapStateToProps(state) {
    // Try to get locale from state,
    // but since we were invoked by an error, the state might be unavailable
    let locale
    try {
        locale = imported.getLocale(state)
    } catch (error) {
        locale = 'en'
    }

    // Try to get locale from state,
    // but since we were invoked by an error, the state might be unavailable
    let isSteam
    try {
        isSteam = imported.isSteamStartup(state)
    } catch (error) {
        isSteam = false
    }

    const fallback = getFallbackAds(isSteam, locale)

    return {
        src: fallback.src,
        onClick: () => launcherOpenUrl(fallback.link),
    }
}

export default connect(mapStateToProps)(ErrorBoundary)



// WEBPACK FOOTER //
// ./src/features/Creatives/error/index.js